import { defineStore } from 'pinia';

export const useInputsStore = defineStore('inputs', {
	state: () => ({
		inputs: new Set(),
		valid: []
	}),
	
	getters: {
		isValidAll: (state) => {
			return state.valid
				.filter(el => !!el.ref.required)
				.every(el => el.ref.required && el.valid);
		}
	},

	actions: {
		add(ref) {
			if (!this.inputs.has(ref)) {
				this.inputs.add(ref);
				this.valid.push({
					ref: ref,
					valid: false
				});
			}
		},
		remove(ref) {
			this.inputs.delete(ref);
			this.valid = this.valid.filter(el => el.ref !== ref);
		},
		setValid(ref, value) {
			this.valid.find(el => el.ref === ref).valid = value;
		}
	}
});
